import { ReactElement, forwardRef } from 'react';

import { ButtonIcon } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

import { useDialogContext } from './context';

export type TriggerButtonIconProps = {
  icon: ReactElement;
  tooltip?: string;
  'aria-label': string;
  disabled?: boolean;
  className?: string;
};

export const TriggerButtonIcon = forwardRef<
  HTMLButtonElement,
  TriggerButtonIconProps
>((props, ref) => {
  const { icon, tooltip, disabled, ...rest } = props;
  const { onOpen, isLoading } = useDialogContext();

  const button = (
    <ButtonIcon
      ref={ref}
      variant="tertiary"
      size="small"
      disabled={disabled || isLoading}
      onClick={onOpen}
      data-track-action="open-dialog"
      {...rest}
    >
      {icon}
    </ButtonIcon>
  );

  if (!tooltip) return button;

  return (
    <TooltipRoot>
      {button}
      <Tooltip>{tooltip}</Tooltip>
    </TooltipRoot>
  );
});

TriggerButtonIcon.displayName = 'DialogComposite.TriggerButtonIcon';

export default TriggerButtonIcon;
